import { render } from "./ProjectHolder.vue?vue&type=template&id=afa8794a"
import script from "./ProjectHolder.vue?vue&type=script&lang=js"
export * from "./ProjectHolder.vue?vue&type=script&lang=js"

import "./ProjectHolder.vue?vue&type=style&index=0&id=afa8794a&lang=scss&scope=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__